namespace TabAurous.Production {
    export namespace TreeMakingBOMService {
        export const baseUrl = 'Production/TreeMakingBOM';

        export declare function Create(request: Serenity.SaveRequest<TreeMakingBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TreeMakingBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TreeMakingBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TreeMakingBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/TreeMakingBOM/Create",
            Update = "Production/TreeMakingBOM/Update",
            Delete = "Production/TreeMakingBOM/Delete",
            Retrieve = "Production/TreeMakingBOM/Retrieve",
            List = "Production/TreeMakingBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TreeMakingBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
